import { Box, Grid, Skeleton } from "@mui/material"
import ArticleCard from "./articlecard"


const AvailableArticles = (props) => {
    const { articles, loading, selected, setSelected, match } = props

    const onClick = (id) => {
        setSelected(id)
    }

    return (
        <>
            {loading ? (
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(2, 1fr)",
                            md: "repeat(3, 1fr)",
                            lg: "repeat(4, 1fr)",
                            xl: "repeat(5, 1fr)",
                        },
                        gap: 2,
                        pt: 2,
                    }}
                >
                    {Array.from({ length: 10 }).map((_, i) => (
                        <Skeleton
                            key={i}
                            variant="rounded"
                            height={180}
                        />
                    ))}
                </Box>
            ) : (
                <Grid container spacing={2} sx={{ pt: 2 }}>
                    {articles.map((item) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            xl={2.4}
                            key={item.id}
                        >
                            <ArticleCard
                                item={item}
                                onClick={onClick}
                                selectable
                                selected={selected.indexOf(item.id) > -1}
                                match={match}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}

export default AvailableArticles